/* tslint:disable:no-inferrable-types no-trailing-whitespace import-spacing typedef-whitespace align */

import { WindowType       } from './window';
import { DocumentMetadata } from './document.metadata';

/**
 *
 * @class SearchMetadata
 *
 * @brief meta data for search views.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      April 2020
 *
 */
export class SearchMetadata extends DocumentMetadata {

  public search:    string     = '';

  /** the search history */
  private history:              string[] = [];

  /** standard constructor */
  constructor(
    id:       string   = '',
    title:    string   = '',
    search:   string   = '/',
    history:  string[] = [],
    icon:     string   = '<i class="fas fa-search"></i>',
    type: WindowType   = WindowType.Search,
  ) {

    super(id, title, icon, type);

    this.search  = search;
    this.history = history;

  }

  /** convert this element to a simplified form that can be easily serialized */
  public node(init?: any) {

    return super.node({search: this.search, history: this.history});
  }

  /** initialize this element given the data in the simplified node object */
  public fromNode(node: any) {

    super.fromNode(node);

    this.search  = node.search;
    this.history = node.history;
  }
}
